import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { RefreshCw } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function CacheVersionChecker() {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const storedVersion = localStorage.getItem('cacheVersion');
        const response = await axios.get(`${API_URL}/cache-version`);
        const serverVersion = response.data.version;

        if (storedVersion && storedVersion !== serverVersion && serverVersion !== 'initial') {
          setShowUpdate(true);
        }
        
        localStorage.setItem('cacheVersion', serverVersion);
      } catch (error) {
        // Silently fail
      }
    };

    // Check on mount
    checkVersion();

    // Check every 30 seconds
    const interval = setInterval(checkVersion, 30000);

    return () => clearInterval(interval);
  }, []);

  const handleRefresh = () => {
    // Clear all caches
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => caches.delete(name));
      });
    }
    
    // Force hard reload
    window.location.reload(true);
  };

  if (!showUpdate) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-slide-in">
      <div className="bg-emerald-500 text-white px-4 py-3 rounded-xl shadow-lg flex items-center gap-3">
        <RefreshCw className="w-5 h-5" />
        <span className="text-sm font-medium">Nova versão disponível</span>
        <button
          onClick={handleRefresh}
          className="bg-white/20 hover:bg-white/30 px-3 py-1 rounded-lg text-sm font-medium transition-colors"
        >
          Atualizar
        </button>
      </div>
    </div>
  );
}
